import { Controller } from "@hotwired/stimulus"
import * as WebAuthnJSON from "@github/webauthn-json"

// Drives the WebAuthn ceremony for both sign-up (register) and sign-in
// (authenticate): fetch options → navigator.credentials → POST result.
export default class extends Controller {
  static values = { mode: String, optionsUrl: String, verifyUrl: String }
  static targets = ["email", "error", "submit"]

  async submit(event) {
    event.preventDefault()
    this.errorTarget.textContent = ""
    this.submitTarget.disabled = true
    try {
      const optRes = await this.#post(this.optionsUrlValue, { email: this.emailTarget.value })
      const options = await optRes.json()
      if (!optRes.ok) throw new Error(options.error || "Could not start")

      const credential = this.modeValue === "register"
        ? await WebAuthnJSON.create({ publicKey: options })
        : await WebAuthnJSON.get({ publicKey: options })

      const verifyRes = await this.#post(this.verifyUrlValue, { credential })
      const data = await verifyRes.json()
      if (!verifyRes.ok) throw new Error(data.error || "Verification failed")

      window.location = data.redirect || "/"
    } catch (e) {
      this.errorTarget.textContent = e.message || String(e)
      this.submitTarget.disabled = false
    }
  }

  #post(url, body) {
    return fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content || ""
      },
      body: JSON.stringify(body)
    })
  }
}
